// extracted by mini-css-extract-plugin
export var fullHeightState = "_4h-7";
export var headerCell = "_4h-1";
export var loadingStateCell = "_4h-4";
export var rowWrapper = "_4h-3";
export var standaloneTable = "_4h-8";
export var standaloneTableWithBodyFill = "_4h-9";
export var stateCell = "_4h-5";
export var table = "_4h-0";
export var tableBodyFiller = "_4h-6";
export var white = "_4h-2";